var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitsicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ benefits",
    clipPath: "url(#clip0_14_9174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.5 17.5V10.5C38.5 8.575 36.925 7 35 7H7C5.075 7 3.5175 8.575 3.5175 10.5V17.5C5.4425 17.5 7 19.075 7 21C7 22.925 5.4425 24.5 3.5 24.5V31.5C3.5 33.425 5.075 35 7 35H35C36.925 35 38.5 33.425 38.5 31.5V24.5C36.575 24.5 35 22.925 35 21C35 19.075 36.575 17.5 38.5 17.5ZM35 14.945C32.9175 16.1525 31.5 18.4275 31.5 21C31.5 23.5725 32.9175 25.8475 35 27.055V31.5H7V27.055C9.0825 25.8475 10.5 23.5725 10.5 21C10.5 18.41 9.1 16.1525 7.0175 14.945L7 10.5H35V14.945ZM15.8725 28L21 24.71L26.1275 28L24.57 22.12L29.2775 18.27L23.205 17.9025L21 12.25L18.7775 17.885L12.705 18.2525L17.4125 22.1025L15.8725 28Z",
    fill: "#007078"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_9174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsicon);
export default __webpack_public_path__ + "static/media/Benefits.icon.5703ebc4f4f7eaf8eb0ac08a333e5611.svg";
export { ForwardRef as ReactComponent };